/**
 * Returns the formatted phone number: (###) ###-####.
 * 
 * @param {Input field phone number value} value 
 * @returns The formatted phone number: (###) ###-####.
 */
export const formatPhoneNumber = (value) => {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;
  
    // clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, '');
  
    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;
  
    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code to early
  
    if (phoneNumberLength < 4) return phoneNumber;
  
    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
  
    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
};

/**
 * Returns the normal phone number: ##########.
 * 
 * @param {Input field phone number value} value 
 * @returns The normal phone number: ##########.
 */
export const unformatPhoneNumber = (value) => {
  return value.replace(/\D/g, '').substring(0, 10);
};

/**
 * Returns the formatted postal code.
 * 
 * @param {Input field postal code value} postalCode 
 * @returns The formatted postal code.
 */
export const formatPostal = (postalCode) => {
  let newValue = postalCode.replace(/\W/g, '').substring(0, 6);
  let formattedValue = newValue.toUpperCase();

  if (newValue.length > 3) {
    formattedValue = `${newValue.substring(0, 3)} ${newValue.substring(3)}`.toUpperCase();
  }

  return formattedValue;
};

/**
 * Returns the normal postal code.
 *
 * @param {Input field postal code value} postalCode 
 * @returns The normal postal code.
 */
export const unformatPostal = (postalCode) => {
  return postalCode.replace(/\s/g, '').toUpperCase().substring(0, 6);
};